import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '../';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__en-NL.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['en-NL'].layout },
  seo: {
    ...sharedConfig['en-NL'].seo,
    title: 'Privacy Policy • Lemonade Insurance NL',
    metaTitle: 'Privacy Policy • Lemonade Insurance NL',
    description:
      'Read Lemonade Netherlands’ Privacy Policy to learn how we collect, use, protect, and manage your personal data when using our services.',
  },
  MDXContent: content as DocumentTypes,
};
